import { useCallback } from 'react'
import PropTypes from 'prop-types'
import Popup, { PopupCloseButton } from '@aytm/lib/rfd-ui/components/basic/popup'

const statuses = {
  kudos: {
    no: 'We\'ll send a "Thank you note" to the respondent on your behalf if you find their answer especially thoughtful and helpful',
    revertable:
      "This response was given a kudos but we haven't sent it yet. You can still remove it by clicking the icon again.",
    true: 'This response was given a kudos and respondent received a "Thank you" note on your behalf.'
  },
  reject: {
    no: "You can reject up to 5% of the respondents based on suboptimal open ends within a week after fielding. We'll auto-replace them with fresh responses free of charge."
  },
  approve: {
    no: "You can reject up to 5% of the respondents based on suboptimal open ends within a week after fielding. We'll auto-replace them with fresh responses free of charge."
  }
}

const NotificationPopup = ({ children, action, type, status, disabled, onClosePopup }) => {
  const closePopup = useCallback(() => {
    onClosePopup(action)
  }, [action, onClosePopup])

  return disabled ? (
    <>{children}</>
  ) : (
    <Popup
      width="215px"
      trigger="hover"
      direction="topleft"
      popupOffset={5}
      portal
      hideOtherPopupsOnShow
      content={() => (
        <>
          <PopupCloseButton onClose={closePopup}>
            <i className="icon-aytmfd-x-v2" />
          </PopupCloseButton>
          <div className="response-header-notification-text">{statuses[type][status]}</div>
        </>
      )}
    >
      {children}
    </Popup>
  )
}

NotificationPopup.propTypes = {
  children: PropTypes.any,
  action: PropTypes.string,
  type: PropTypes.string,
  status: PropTypes.string,
  disabled: PropTypes.bool,
  onClosePopup: PropTypes.func
}

NotificationPopup.displayName = 'NotificationPopup'

export default NotificationPopup
